export const DECIMAL_TO_FRACTIONAL_MAP = [
    { dec: 1.001, frac: '1/1000' },
    { dec: 1.01, frac: '1/100' },
    { dec: 1.02, frac: '1/50' },
    { dec: 1.03, frac: '1/33' },
    { dec: 1.04, frac: '1/25' },
    { dec: 1.05, frac: '1/20' },
    { dec: 1.06, frac: '1/16' },
    { dec: 1.07, frac: '1/14' },
    { dec: 1.08, frac: '1/12' },
    { dec: 1.1, frac: '1/10' },
    { dec: 1.11, frac: '1/9' },
    { dec: 1.13, frac: '1/8' },
    { dec: 1.14, frac: '1/7' },
    { dec: 1.17, frac: '1/6' },
    { dec: 1.18, frac: '2/11' },
    { dec: 1.2, frac: '1/5' },
    { dec: 1.22, frac: '2/9' },
    { dec: 1.25, frac: '1/4' },
    { dec: 1.29, frac: '2/7' },
    { dec: 1.3, frac: '3/10' },
    { dec: 1.33, frac: '1/3' },
    { dec: 1.36, frac: '4/11' },
    { dec: 1.4, frac: '2/5' },
    { dec: 1.44, frac: '4/9' },
    { dec: 1.5, frac: '1/2' },
    { dec: 1.53, frac: '8/15' },
    { dec: 1.57, frac: '4/7' },
    { dec: 1.62, frac: '8/13' },
    { dec: 1.67, frac: '2/3' },
    { dec: 1.7, frac: '7/10' },
    { dec: 1.73, frac: '8/11' },
    { dec: 1.75, frac: '3/4' },
    { dec: 1.8, frac: '4/5' },
    { dec: 1.83, frac: '5/6' },
    { dec: 1.85, frac: '17/20' },
    { dec: 1.87, frac: '20/23' },
    { dec: 1.91, frac: '10/11' },
    { dec: 1.95, frac: '19/20' },
    { dec: 2.0, frac: '1/1' },
    { dec: 2.05, frac: '21/20' },
    { dec: 2.1, frac: '11/10' },
    { dec: 2.15, frac: '23/20' },
    { dec: 2.2, frac: '6/5' },
    { dec: 2.25, frac: '5/4' },
    { dec: 2.3, frac: '13/10' },
    { dec: 2.35, frac: '27/20' },
    { dec: 2.38, frac: '11/8' },
    { dec: 2.4, frac: '7/5' },
    { dec: 2.45, frac: '29/20' },
    { dec: 2.5, frac: '3/2' },
    { dec: 2.6, frac: '8/5' },
    { dec: 2.63, frac: '13/8' },
    { dec: 2.7, frac: '17/10' },
    { dec: 2.75, frac: '7/4' },
    { dec: 2.8, frac: '9/5' },
    { dec: 2.88, frac: '15/8' },
    { dec: 2.9, frac: '19/10' },
    { dec: 3.0, frac: '2/1' },
    { dec: 3.1, frac: '21/10' },
    { dec: 3.2, frac: '11/5' },
    { dec: 3.25, frac: '9/4' },
    { dec: 3.3, frac: '23/10' },
    { dec: 3.4, frac: '12/5' },
    { dec: 3.5, frac: '5/2' },
    { dec: 3.6, frac: '13/5' },
    { dec: 3.7, frac: '27/10' },
    { dec: 3.75, frac: '11/4' },
    { dec: 3.8, frac: '14/5' },
    { dec: 4.0, frac: '3/1' },
    { dec: 4.2, frac: '16/5' },
    { dec: 4.33, frac: '10/3' },
    { dec: 4.5, frac: '7/2' },
    { dec: 4.75, frac: '15/4' },
    { dec: 5.0, frac: '4/1' },
    { dec: 5.25, frac: '17/4' },
    { dec: 5.5, frac: '9/2' },
    { dec: 5.75, frac: '19/4' },
    { dec: 6.0, frac: '5/1' },
    { dec: 6.5, frac: '11/2' },
    { dec: 7.0, frac: '6/1' },
    { dec: 7.5, frac: '13/2' },
    { dec: 8.0, frac: '7/1' },
    { dec: 8.5, frac: '15/2' },
    { dec: 9.0, frac: '8/1' },
    { dec: 9.5, frac: '17/2' },
    { dec: 10, frac: '9/1' },
    { dec: 10.5, frac: '19/2' },
];

export const DECIMAL_LOW_MAP = [{ dec: 1.001, frac: '1/1000' }];

export const FRACTIONAL_TO_DECIMAL_MAP = {
    '13/8': 2.62,
    '15/8': 2.87,
    '11/8': 2.37,
    '8/13': 1.61,
    '2/7': 1.28,
    '1/8': 1.12,
};
